// Post-login destinations come from the URL (?redirect=), so they are only
// honoured when they are same-site paths and not another auth page — the
// latter used to bounce the user in a loop between /login and /register.
const AUTH_PATHS = ['/login', '/register', '/forgot-password', '/reset-password']

export function safeRedirect(value: unknown, fallback = '/dashboard'): string {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return fallback
  }
  const path = value.split(/[?#]/)[0]
  if (AUTH_PATHS.some(p => path === p || path.startsWith(p + '/'))) return fallback
  return value
}
